export const menuCategories = [
  {
    id: "starters",
    key: "starters",
    image: "/fotos-menu-categorias/lapas-entradas.webp",
    priceKey: "menu_price_starters",
    nameKey: "menu_cat_starters",
    descKey: "menu_cat_starters_desc",
  },
  {
    id: "fish",
    key: "fish",
    image: "/fotos-menu-categorias/molho-de-peixe-pratos-de-peixe.webp",
    priceKey: "menu_price_fish",
    nameKey: "menu_cat_fish",
    descKey: "menu_cat_fish_desc",
  },
  {
    id: "meat",
    key: "meat",
    image: "/fotos-menu-categorias/assaduras-pratos-de-carne.webp",
    priceKey: "menu_price_meat",
    nameKey: "menu_cat_meat",
    descKey: "menu_cat_meat_desc",
  },
  {
    id: "vegetarian",
    key: "vegetarian",
    image: "/fotos-menu-categorias/salada-queijo-fresco-pratos-vegetarianos.webp",
    priceKey: "menu_price_vegetarian",
    nameKey: "menu_cat_vegetarian",
    descKey: "menu_cat_vegetarian_desc",
  },
  {
    id: "kids",
    key: "kids",
    image: "/fotos-menu-categorias/hamburguer-menu-infantil.webp",
    priceKey: "menu_price_kids",
    nameKey: "menu_cat_kids",
    descKey: "menu_cat_kids_desc",
  },
  {
    id: "desserts",
    key: "desserts",
    image: "/fotos-menu-categorias/queijadas-sobremesas.webp",
    priceKey: "menu_price_desserts",
    nameKey: "menu_cat_desserts",
    descKey: "menu_cat_desserts_desc",
  },
];
